import type { NextPage } from 'next';
import { useSession } from 'next-auth/react';

import { BlockType } from '@web/blocks';

import { ContentBlock } from '@web/components/block-list/content-block';
import { ErrorFrame } from '@web/components/error-frame/error-frame';
import { HeroBlock } from '@web/components/hero-block/hero-block';

import TemplateLayout from '@web/layouts/template/template';

import { UmbracoErrorType } from '@web/services/umbraco/types/basic/ErrorTypes';
import { UmbracoPage } from '@web/services/umbraco/types/documents/UmbracoDocument';
import { HeroBlockType } from '@web/services/umbraco/types/elements/Hero';

export const memberBookingsOverviewPageContentAlias = 'memberBookingsOverviewPage' as const;

export type MemberBookingsOverviewPageData = UmbracoPage<
	typeof memberBookingsOverviewPageContentAlias,
	{
		hero: HeroBlockType;
		blocks: BlockType[];
	}
>;

const MemberBookingsOverviewPageTemplate: NextPage<{ pageData: MemberBookingsOverviewPageData }> = ({ pageData }) => {
	const { status } = useSession();

	if (status === 'unauthenticated') {
		return <ErrorFrame errorType={UmbracoErrorType.Unauthorized} />;
	}

	return (
		<TemplateLayout>
			{pageData.properties.hero && <HeroBlock block={pageData.properties.hero} />}
			{pageData.properties.blocks && <ContentBlock blocks={pageData.properties.blocks} />}
		</TemplateLayout>
	);
};

export default MemberBookingsOverviewPageTemplate;
